
import * as React from "react";
import avatar from '../assets/mahmut-keygubatli.jpg';

import {
    Avatar,
    Grid,
    Container,
} from "tabler-react";
import {
    NavLink,
} from 'react-router-dom';

import './Footer.css';

interface HelloMessageProps {
}

export default class Footer extends React.Component<HelloMessageProps, {}>{
    render() {
        return (
            <div className="areaway-footer">
                <div style={{ display: 'none', backgroundColor: '#c8c8c8', color: '#fff', height: "90px", padding: 5 }}>
                    <Container className="my-footer">
                        <Grid.Row>
                            <Grid.Col width={2}>
                                <Avatar size="xxl" imageURL={avatar} />
                            </Grid.Col>
                            <Grid.Col width={10}>
                                <p>Ich bin nicht der Marktführer – dafür aber kompetent und fair.</p>
                                <p>Mahmut Keygubatli</p>
                            </Grid.Col>
                        </Grid.Row>
                    </Container>
                </div >
                <Container className="lastline-footer">
                    <Grid.Row>
                        <Grid.Col width={12}>
                            <NavLink exact activeClassName="active" to="/Impressum">
                                Impressum
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Datenschutz">
                                Datenschutz
                                </NavLink>
                        </Grid.Col>
                        <Grid.Col width={12}>
                            <div style={{ textAlign: 'right', fontSize: '12px', lineHeight: '21px', marginTop: 8 }}>
                                Copyright <span style={{ verticalAlign: 'super', fontSize: '66%', lineHeight: 0 }}>©</span>2019 by AreaWay
                            </div>
                        </Grid.Col>
                    </Grid.Row>
                </Container>
            </div >
        );
    }
}